import React from 'react';
import { PartyTypes } from 'vdlib';
import VDFMDocument from './VDFMDocument';
import HydraDocument from './HydraDocument';
import FeesDocument from './FeesDocument';
import { I18n as I } from 'react-redux-i18n';

export const getCountrySteps = (CountryID, handleAccept, partyType) => {
  const cyprusSteps = [
    {
      title: <span style={{ fontWeight: 600 }}>VDFM</span>,
      content: (
        <VDFMDocument
          showApproveButton={true}
          showCheckBox={false}
          handleAccept={() => handleAccept(cyprusSteps)}
        />
      ),
    },
    {
      title: <span style={{ fontWeight: 600 }}>HYDRA Insurance</span>,
      content: (
        <HydraDocument
          handleAccept={() => handleAccept(cyprusSteps)}
          showApproveButton={true}
        />
      ),
    },
  ];

  const greekSteps = []
    .concat(
      partyType === PartyTypes.Merchant
        ? {
            title: (
              <span style={{ fontWeight: 600 }}>{I.t('FEES_POLICY')}</span>
            ),
            content: (
              <FeesDocument
                showApproveButton={true}
                showCheckBox={false}
                handleAccept={() => handleAccept(greekSteps)}
              />
            ),
          }
        : []
    )
    .concat([
      {
        title: <span style={{ fontWeight: 600 }}>VDFM</span>,
        content: (
          <VDFMDocument
            showApproveButton={true}
            showCheckBox={false}
            handleAccept={() => handleAccept(greekSteps)}
          />
        ),
      },
    ]);

  if (CountryID === 51) return cyprusSteps;
  else return greekSteps;
};
